export default {
  title: 'Koszyk',
};
